import React from 'react';

import { Icon } from '@chakra-ui/react';
import {
  MdBarChart,
  MdPerson,
  MdHome,
  MdLock,
  MdOutlineShoppingCart,
  MdWallet,
  MdCreditCard,
  MdMoney,
  MdDialpad,
} from 'react-icons/md';

// Admin Imports
import MainDashboard from 'views/admin/default';
import NFTMarketplace from 'views/admin/marketplace';
import Profile from 'views/admin/profile';
import DataTables from 'views/admin/dataTables';

// Auth Imports
import SignInCentered from 'views/auth/signIn';
import SignUpCentered from 'views/auth/signUp';
import Dashboard from 'views/admin/dashboard';
import Networks from 'views/admin/networks';
import Analytics from 'views/admin/analytics';
import Wallets from 'views/admin/wallets';
import CryptoTransactions from 'views/admin/cryptoTransactions';
import CardTransactions from 'views/admin/cardTransactions';
import Fiat from 'views/admin/fiat';
import Cards from 'views/admin/cards';
import Account from 'views/admin/account';

const routes = [
  // Added Routes
  {
    name: 'Dashboard',
    layout: '/admin',
    path: '/dashboard',
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: <Dashboard />,
  },
  {
    name: 'Networks',
    layout: '/admin',
    path: '/networks',
    icon: <Icon as={MdBarChart} width="20px" height="20px" color="inherit" />,
    component: <Networks />,
  },
  // Analytics route - not shown in sidebar but accessible via direct navigation
  {
    name: 'Analytics',
    layout: '/admin',
    path: '/analytics',
    component: <Analytics />,
    hideFromSidebar: true,
  },
  {
    name: 'Crypto Wallets',
    layout: '/admin',
    path: '/wallets',
    icon: <Icon as={MdWallet} width="20px" height="20px" color="inherit" />,
    component: <Wallets />,
  },
  {
    name: 'Crypto Transactions',
    layout: '/admin',
    path: '/crypto-transactions/:network/:address',
    component: <CryptoTransactions />,
    hideFromSidebar: true,
  },
  {
    name: 'Card Transactions',
    layout: '/admin',
    path: '/card-transactions/:cardId',
    component: <CardTransactions />,
    hideFromSidebar: true,
  },
  {
    name: 'Fiat Wallets',
    layout: '/admin',
    path: '/fiat',
    icon: <Icon as={MdMoney} width="20px" height="20px" color="inherit" />,
    component: <Fiat />,
  },
  {
    name: 'Payment Cards',
    layout: '/admin',
    path: '/cards',
    icon: <Icon as={MdCreditCard} width="20px" height="20px" color="inherit" />,
    component: <Cards />,
  },
  {
    name: 'Profile',
    layout: '/admin',
    path: '/account',
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    component: <Account />,
  },


  {
    name: 'Main Dashboard',
    layout: '/admin',
    path: '/default',
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: <MainDashboard />,
  },
  {
    name: 'NFT Marketplace',
    layout: '/admin',
    path: '/nft-marketplace',
    icon: (
      <Icon
        as={MdOutlineShoppingCart}
        width="20px"
        height="20px"
        color="inherit"
      />
    ),
    component: <NFTMarketplace />,
    secondary: true,
  },
  {
    name: 'Data Tables',
    layout: '/admin',
    icon: <Icon as={MdBarChart} width="20px" height="20px" color="inherit" />,
    path: '/data-tables',
    component: <DataTables />,
  },
  {
    name: 'Profile',
    layout: '/admin',
    path: '/profile',
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    component: <Profile />,
  },
  {
    name: 'Sign Up',
    layout: '/auth',
    path: '/sign-up',
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: <SignUpCentered />,
  },
  {
    name: 'Sign In',
    layout: '/auth',
    path: '/sign-in',
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: <SignInCentered />,
  },
];

export default routes;
